import { FC } from 'react';
import styled from 'styled-components';
import { isEmpty } from 'lodash';

import { LocaleSwitcher } from 'modules/templateEditor/common/LocaleSwitcher';
import { ALIGNMENT } from 'ui/selects';
import { useLocaleSettingsContext } from 'modules/campaigns/lib/contexts/LocaleSettingsContext';

import { SendTestMessage, OverflowButton } from '.';
import { ErrorWarningBanner } from '../ErrorWarningBanner';

const Container = styled.div`
  border-bottom: ${({ theme }) => `${theme.spacing.values.single} solid #bdbdbd`};
  display: flex;
  flex: 0 0 auto;
  justify-content: flex-start;
  padding: ${({ theme }) => theme.spacing.utils.pxToRem(15)};
`;

const Left = styled.div`
  align-items: flex-start;
  display: flex;
  flex: 1 1 auto;
  gap: ${({ theme }) => theme.spacing.values.threeEights};
  justify-content: flex-start;
`;

const Right = styled.div`
  align-items: flex-start;
  display: flex;
  flex: 0 0 auto;
  gap: ${({ theme }) => theme.spacing.values.threeEights};
  justify-content: flex-start;
`;

export const ContentControlBar: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { locales } = useLocaleSettingsContext();

  return (
    <Container>
      <Left>
        {!isEmpty(locales) && <LocaleSwitcher horizontalAlignment={ALIGNMENT.LEFT} />}
        {children}
      </Left>
      <Right>
        <ErrorWarningBanner isDesign />
        <SendTestMessage />
        <OverflowButton />
      </Right>
    </Container>
  );
};
